export type AuthStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

/** Platform identity lives on the server even when iframe storage is unavailable. */
export function browserAuthStorage(): AuthStorage {
  const memory = new Map<string, string>();
  let persistent: Storage | null;
  try {
    persistent = window.localStorage;
  } catch {
    persistent = null;
  }
  return {
    getItem(key) {
      try {
        if (!persistent) return memory.get(key) ?? null;
        const value = persistent.getItem(key);
        if (value === null) memory.delete(key);
        else memory.set(key, value);
        return value;
      } catch {
        persistent = null;
        return memory.get(key) ?? null;
      }
    },
    setItem(key, value) {
      memory.set(key, value);
      try {
        persistent?.setItem(key, value);
      } catch {
        persistent = null;
      }
    },
    removeItem(key) {
      memory.delete(key);
      try {
        persistent?.removeItem(key);
      } catch {
        persistent = null;
      }
    },
  };
}

export function platformAuthStorage(
  storage: AuthStorage,
  appId: string,
  provider: "vkplay" | "vkgames" = "vkplay",
): AuthStorage {
  const key = (name: string) =>
    `frontier.${provider}.${appId}.${name.replace(/^frontier\./, "")}`;
  return {
    getItem: (name) => storage.getItem(key(name)),
    setItem: (name, value) => storage.setItem(key(name), value),
    removeItem: (name) => storage.removeItem(key(name)),
  };
}
